<script setup lang="ts">
import HasPermission from "@/components/HasPermission.vue";
import StyledButton from "@/components/StyledButton.vue";
import StyledInput from "@/components/StyledInput.vue";
import useRole from "@/modules/roles/composables/useRole";
import { Role } from "@/modules/roles/composables/useRoles";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { reactive, ref, watch } from "vue";
import { useToast } from "vue-toastification";

interface Props {
  role: Role;
}

const toast = useToast();
const props = defineProps<Props>();

const emits = defineEmits(["handleChangeName"]);

const form = reactive({
  name: props.role?.name ?? "",
});

watch(
  () => props.role,
  (role) => {
    form.name = role?.name ?? "";
  },
);

const isEditing = ref(false);

const handleChangeName = () => {
  if (form.name === props.role.name) {
    toast.info("El nombre del rol no ha cambiado");
    return;
  }

  emits("handleChangeName", form.name);
  isEditing.value = false;
};
</script>

<template>
  <div v-if="!isEditing">
    <h1 class="text-lg font-bold">Nombre del rol: {{ role.name }}</h1>

    <HasPermission name-permission="update-internal" :entity-type="'roles'">
      <StyledButton
        class="bg-[#253C70] text-white ml-auto"
        @click="isEditing = true"
      >
        Editar
      </StyledButton>
    </HasPermission>
  </div>

  <form v-else @submit.prevent="handleChangeName" class="grid gap-3">
    <StyledInput label="Nombre del rol" v-model="form.name" />

    <HasPermission name-permission="update-internal" :entity-type="'roles'">
      <div class="flex gap-3 justify-end">
        <StyledButton
          class="bg-[#253C70] text-white"
          v-if="role.name !== 'Master'"
        >
          Guardar
        </StyledButton>

        <StyledButton
          class="bg-red-500 text-white hover:bg-red-600"
          @click="isEditing = false"
        >
          Cancelar
        </StyledButton>
      </div>
    </HasPermission>
  </form>
</template>

<style scoped></style>
